export enum WomanCaseTypeEnum {

    PREGNANT = 'woman.pregnant',
    LACTATING = 'woman.lactating'

}
